import React from 'react';

function WindowChecked(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M3.875 3H20.125C21.1602 3 22 3.83982 22 4.875V19.125C22 20.1602 21.1602 21 20.125 21H3.875C2.83982 21 2 20.1602 2 19.125V4.875C2 3.83982 2.83982 3 3.875 3ZM3.25 8.25V19.125C3.25 19.4698 3.53018 19.75 3.875 19.75H20.125C20.4698 19.75 20.75 19.4698 20.75 19.125V8.25H3.25ZM20.75 7H3.25V4.875C3.25 4.53018 3.53018 4.25 3.875 4.25H20.125C20.4698 4.25 20.75 4.53018 20.75 4.875V7Z"
        fillRule="evenodd"
      />
      <path d="M15.1945 10.6831C15.4348 10.439 15.8244 10.439 16.0648 10.6831C16.2784 10.9 16.3021 11.2368 16.136 11.4804L16.0648 11.5669L11.5765 16.1253C11.1279 16.581 10.419 16.6113 9.93524 16.216L9.83519 16.1248L8.42473 14.6889C8.18469 14.4446 8.18514 14.0488 8.42574 13.805C8.63961 13.5883 8.97124 13.5646 9.21088 13.7337L9.29603 13.8061L10.706 15.2414L15.1945 10.6831Z" />
    </svg>
  );
}

export default WindowChecked;
